import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { GoogleButton } from "@/pages/Login";
import { Heart } from "lucide-react";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to Finding Love in Canada!");
      navigate("/profile");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-140px)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Heart className="w-8 h-8 text-primary fill-primary mx-auto mb-3" />
          <h1 className="font-serif text-4xl">Join the story</h1>
          <p className="text-muted-foreground mt-2">Free forever. No swiping, just people.</p>
        </div>
        <div className="bg-card border border-border rounded-3xl p-8 shadow-sm">
          <GoogleButton label="Sign up with Google" />
          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-border" />
            <span className="text-xs text-muted-foreground">or with email</span>
            <div className="flex-1 h-px bg-border" />
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="name">Your name</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name-input" className="mt-1.5 h-11 rounded-xl" placeholder="Alex Robinson" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email-input" className="mt-1.5 h-11 rounded-xl" placeholder="you@example.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password-input" className="mt-1.5 h-11 rounded-xl" placeholder="At least 6 characters" />
            </div>
            <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full h-11 rounded-full bg-primary hover:bg-primary/90">
              {loading ? "Creating…" : "Create account"}
            </Button>
          </form>
          <div className="text-center text-sm text-muted-foreground mt-6">
            Already a member? <Link to="/login" className="text-primary hover:underline" data-testid="link-to-login">Log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
